import { FC } from 'react';
import { observer } from 'mobx-react';
import { generatePath, Link } from 'react-router-dom';
import { Button, Stack } from '@servicetitan/design-system';
import { IPartnerOverview } from '@servicetitan/marketing-tenant-management-api';
import { withRoot } from '../../../utils/with-root';
import { AccountManagementRoutes } from '../../../utils/routes';
import { TableCellDataProps } from '../../../../common/utils/types';

export const ActionsCell: FC<TableCellDataProps<IPartnerOverview>> = observer(
    ({ style, colSpan, className, ariaColumnIndex, dataItem }) => {
        const relativePath = generatePath(AccountManagementRoutes.managePartner, {
            externalPartnerId: dataItem.id,
        });

        return (
            <td
                colSpan={colSpan}
                style={{ ...style }}
                className={className}
                aria-colindex={ariaColumnIndex}
            >
                <Stack justifyContent="center">
                    <Link to={withRoot(relativePath)}>
                        <Button size="xsmall">Manage</Button>
                    </Link>
                </Stack>
            </td>
        );
    },
);
